import React, { useState, useEffect, useContext } from "react"
import { navigate } from "gatsby"

import Layout from "src/components/core/templates/layout"
import Hero from "src/components/core/templates/hero"
import Snackbar from "src/components/core/molecules/snackbar"

import Seo from "src/components/seo"
import { container, input } from "./login.module.css"

import { UserContext } from "src/context/UserContext"
import Input from "src/components/core/atoms/input"
import Button from "src/components/core/atoms/button"

const Login = ( props ) => {
  const returnTo = props?.location?.state?.returnTo || '/user/dashboard'

  const { signIn, authUser, isAuthenticatedLocally } = useContext( UserContext )
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  })
  const [ loginError, setLoginError ] = useState( '' )

  const pageConfig = {
    title: "Tag Supplies",
    description: "Log in.",
    variant: "box",
  }

  const handleChange = e => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    })
  }

  const doSubmit = async ( e ) => {
    e.preventDefault()
    const res = await signIn( credentials )
    if ( res.error ) {
      setLoginError( res.error )
      setTimeout( () => setLoginError( '' ), 5000 )
    }
  }

  useEffect( () => {
    if ( authUser && isAuthenticatedLocally() ) {
      navigate( returnTo )
    }
  }, [ authUser, isAuthenticatedLocally, returnTo ] )
  
  return (
    <>
      <Layout>
        <Seo title="Login" />
        <Hero pageConfig={pageConfig} />
        <div className={ container }>
          <p>Please enter your credentials to log in</p>
          <form onSubmit={ doSubmit }>
            <div className={ input }>
              <Input.Field
                name="email"
                type="email"
                value={credentials.email}
                onChange={ handleChange }
                label="Email"
              />
              <Input.Field
                name="password"
                type="password"
                value={credentials.password}
                onChange={ handleChange }
                label="Password"
              />
            </div>
            <Button variant="solid" type="submit">Log In</Button>
          </form>
          <Button variant="underlined" >Forgot your password?</Button>
        </div>
      </Layout>
      <Snackbar.Feedback
        header="Login error"
        variant="alert"
        message={ `${ loginError }` }
        visible={ loginError }
      />
    </>
  )
}

export default Login
